export const APP_ROUTES = {
  SPLASH_SCREEN: "/splash-screen",
  // Onboarding entry. Temporarily points straight at the first step while the
  // /get-started intro is disabled (public route commented out) pending a
  // rebrand. Restore to "/get-started" to re-enable the intro screen.
  ONBOARDING_START: "/profiling/step-name",
  ONBOARDING_DIAGNOSTIC: "/diagnostic",
  ONBOARDING_FIRST_STEP: "/profiling/step-name",
  /** Where /diagnostic rejoins the step router. */
  ONBOARDING_GOAL_STEP: "/profiling/step-goal",
  /** Static welcome screen after app-preview; its CTA enters the app. */
  ONBOARDING_MEET: "/profiling/step-meet-nutricoach",
  LOGIN: "/login",
  REGISTER: "/register",
  REGISTER_VERIFICATION: "/register-verification",
  OVERVIEW: "/overview",
  MY_PLAN: "/plans/my-plan",
  SAVED_MEALS: "/plans/saved-meals",
  SETTINGS: "/profile",
  SETTINGS_AND_TOOLS: "/settings-and-tools",
} as const;

export const DEFAULT_AUTHENTICATED_ROUTE = APP_ROUTES.OVERVIEW;
